import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import { SEND_CONFIGS } from "../../config/sendConfigs";
import Menu from "../Menu";

const SendSchedule = () => {
  return (
    <>
      <Menu />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <CommonSendComponent config={SEND_CONFIGS.schedule} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SendSchedule;
